import { useState, useEffect } from "react";
import i18n from "../i18n/i18n";

/**
 * Custom hook for using translations with automatic re-renders
 * when the language changes
 */
export function useAppTranslation() {
  // Force re-render when language changes
  const [, forceUpdate] = useState({});

  useEffect(() => {
    // Function to force a re-render
    const handleLanguageChanged = () => {
      forceUpdate({});
    };

    // Set up language change listener
    i18n.on("languageChanged", handleLanguageChanged);

    // Clean up
    return () => {
      i18n.off("languageChanged", handleLanguageChanged);
    };
  }, []);

  // Return a safe translation function that always returns a string
  const t = (key: string, options?: any): string => {
    try {
      const translation = i18n.t(key, options);
      // Handle potential non-string return values
      return translation && typeof translation === "object"
        ? JSON.stringify(translation)
        : String(translation);
    } catch (error) {
      console.error(`Translation error for key: ${key}`, error);
      return key; // Fallback to returning the key itself
    }
  };

  return {
    t,
    i18n,
    changeLanguage: (lng: string) => i18n.changeLanguage(lng),
    language: i18n.language,
  };
}
